import styled from 'styled-components'
import { COLORS } from '@assets/styles/colors'

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	background: linear-gradient(90deg, #c3d6f7 0%, #81a1dc 100%);
	padding: 11px 14px;
	border-radius: 15px;
`

export const Title = styled.div`
	font-size: 12px;
`

export const Subtitle = styled.div`
	padding: 0;
	font-size: 10px;
	margin-top: 4px;
`

export const Progress = styled.div`
	margin-top: 4px;
	width: 100%;
	height: 5px;
	background-color: white;
`

export const ProgressFilled = styled.div<{ $percentage: number }>`
	width: ${props => props.$percentage}%;
	height: 100%;
	background-color: ${COLORS.DECORATIVE_YELLOW};
`

export const NewAchievementDescribe = styled.div`
	align-self: flex-end;
	font-size: 8px;
	color: white;
`

export const Arrow = styled.i`
	font-size: 24px;
	display: flex;
	align-items: center;
	justify-content: center;
	height: 25px;
	width: 25px;
	border-radius: 100%;
	background-color: white;
`
